import { render, staticRenderFns } from "./MinusBase.vue?vue&type=template&id=223973fe&scoped=true&"
import script from "./MinusBase.vue?vue&type=script&lang=ts&"
export * from "./MinusBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223973fe",
  null
  
)

export default component.exports